<template>
  <div class="rt-header-title-wrapper">
    <div class="header-title">{{ title }}</div>
    <div v-if="subTitle" class="header-sub-title-wrapper">
      <span class="header-sub-title">{{ subTitle }}</span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtHeaderTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeaderTitle.vue?4974fe6a